export const chartALabels = Array.from({ length: 50 }, (_, i) => (i * 0.04).toFixed(2));

export const chartAOptions = {
  animation: {
    duration: 0,
  },
  legend: {
    display: false,
  },

  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        id: "x",
        scaleLabel: {
          display: false,
          labelString: "",
          fontStyle: "bold",
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: "s (t)",
          fontStyle: "bold",
        },
      },
    ],
  },
};

export const chartAAnnotations = {
  type: "line",
  display: true,
  scaleID: "x",
  value: 0,
  borderColor: "rgba(0, 0, 128, 1)",
  borderWidth: 3,
};
